<script setup lang="ts">
import { type Exhibition, getFileList, type QingflowFile } from '@/api/exhibition';
import { LazyCarousels } from '@/components';
import { getFileType } from '@repo/utils';
import { onMounted, ref } from 'vue';
import { Image } from 'vant';
import { useRouter } from 'vue-router';
import { $t } from "../../../../../src/locales";

const props = defineProps<{ exhibition: Exhibition }>();

type FileItem = QingflowFile & { type: 'video' | 'image' | 'unknown' }
const imageList = ref<FileItem[]>([]);

onMounted(async () => {
  const images = await getFileList({ ...props.exhibition.description, enterpriseId: props.exhibition.enterpriseId });
  imageList.value = [...images.map(item => ({ ...item, type: getFileType(item.name) }))];
});

const router = useRouter();
const onClickEntry = async (externalId: string) => {
  await router.push({
    name: 'exhibition',
    params: {
      externalId: externalId
    }
  });
};
</script>

<template>
  <div>
    <div :class="$style.exhibitionName">
      {{ props.exhibition.name }}
      <div :class="$style.entryButton" @click="onClickEntry(props.exhibition.externalId)">{{ $t('exhibition.clickme') }}</div>
    </div>

    <LazyCarousels
      :query="{
      ...props.exhibition.coverImageData,
      enterpriseId :props.exhibition.enterpriseId}"
    />
    <div style="text-align: center; font-size: 14px; margin-bottom: 20px;">{{ $t('exhibition.leftRight') }}</div>

    <template v-for="file of imageList" :key="file.url">
      <Image
        v-if="file.type==='image'"
        width="100%"
        :alt="file.name"
        :src="file.url"
      />
      <video
        v-else-if="file.type==='video'"
        style="width: 100%;"
        preload="metadata"
        controls
        :autoplay="false"
      >
        <source :src="file.url" type="video/mp4" />
      </video>
    </template>

  </div>
</template>

<style module>
.exhibitionName {
  font-size: 20px;
  font-weight: bold;
  margin: 10px 0 20px;
  text-align: center;
  position: relative;
}

.entryButton {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #409EFF;
  cursor: pointer;
}
</style>